import axios from 'axios';

const API_URL = 'https://fooddiscovery-mern.herokuapp.com//api/test/';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }
}

export default new UserService();
